import { render } from "./TyC.vue?vue&type=template&id=0a9960ba"
import script from "./TyC.vue?vue&type=script&lang=js"
export * from "./TyC.vue?vue&type=script&lang=js"

import "./TyC.vue?vue&type=style&index=0&id=0a9960ba&lang=scss"
script.render = render

export default script